<template>
	<footer class="footer">
		<div class="container">
			<div class="footer__content">
				<a  @click="sendEvent('logo_NOTK','m_logo_NOTK')" href="http://russian.visitkorea.or.kr/rus/index.kto" target="_blank" class="footer__item footer__item--5"></a>
				<a href="https://www.koreanair.com/ru/ru" target="_blank" class="footer__item footer__item--1"></a>
				<div  @click="sendEvent('logo_sodruzhestvo_30','m_logo_sodruzhestvo_30')" class="footer__item footer__item--2"></div>
				<a  @click="sendEvent('logo_Korejskij_kulturnyj_centr','m_logo_kkc')" href="https://russia.korean-culture.org/ru" target="_blank" class="footer__item footer__item--3"></a>
				<a @click="sendEvent('logo_Korean_air','m_logo_Korean_air')" href="http://www.k-heritage.tv/main/en" target="_blank" class="footer__item footer__item--4"></a>
			</div>
		</div>
	</footer>
</template>

<script>
	export default {
		name: 'Footer',
		methods: {
			sendEvent(event, eventMob) {
				if (window.innerWidth > 960) {
					this.$gtag.event('click', {event_category: 'link', 'event_label': event});
				} else {
					this.$gtag.event('click', {event_category: 'link', 'event_label': eventMob});
				}
			},
		}
	}
</script>

<style lang="sass">
	.footer
		background-color: $white
		position: relative
		bottom: 0
		width: 100%
		height: vw(70px)
		@media screen and (max-width: 1000px)
			height: vwm(155px)
			position: static
		&--main
			position: static
			height: vw(80px)
			@media screen and (max-width: 1000px)
				height: vwm(96px)
		&__content
			display: flex
			justify-content: center
			margin-left: vw(-34px)
			@media screen and (max-width: 1000px)
				margin-left: 0
				padding-top: vwm(9px)
				flex-wrap: wrap
		&__item
			display: flex
			align-items: center
			position: relative
			margin-right: vw(10px)
			margin-left: vw(10px)
			&:after
				content: ''
				width: 1px
				height: vw(12px)
				background-color: rgba(0, 46, 86, 0.4)
				display: block
				position: absolute
				right: vw(13px)
				@media screen and (max-width: 1000px)
					height: vwm(9px)
					right: vwm(10px)
			&:last-child
				&:after
					display: none
			&--1
				background-image: url(../assets/images/logo-1.png)
				background-size: contain
				background-repeat: no-repeat
				width: vw(187px)
				height: vw(60px)
				margin-top: vw(3px)
				margin-right: 0
				order: 4
				@media screen and (max-width: 1000px)
					width: vwm(150px)
					height: vwm(50px)
					margin-left: vwm(0px)
					margin-top: vwm(14px)
					margin-right: vwm(-43px)
			&--2
				background-image: url(../assets/images/logo-2.svg)
				background-size: contain
				background-repeat: no-repeat
				width: vw(132px)
				height: vw(24px)
				margin-top: vw(22px)
				margin-left: vw(38px)
				order: 3
				@media screen and (max-width: 1000px)
					width: vwm(104px)
					height: vwm(19px)
					margin-left: vwm(-10px)
					margin-top: vwm(28px)
				&:after
					right: vw(-19px)
			&--3
				background-image: url(../assets/images/logo-3.png)
				background-size: contain
				background-repeat: no-repeat
				width: vw(107px)
				height: vw(36px)
				margin-top: vw(15px)
				margin-left: vw(24px)
				order: 2
				@media screen and (max-width: 1000px)
					width: vwm(83px)
					height: vwm(27px)
					margin-right: vwm(12px)
					margin-left: vwm(17px)
					margin-top: vwm(15px)
					&:after
						display: none !important
				&:after
					right: vw(-19px)
			&--4
				background-image: url(../assets/images/logo-4.png)
				background-size: contain
				background-repeat: no-repeat
				width: vw(136px)
				height: vw(56px)
				margin-top: vw(3px)
				margin-left: vw(24px)
				order: 5
				@media screen and (max-width: 1000px)
					width: vwm(115px)
					height: vwm(36px)
					margin-right: vwm(-17px)
					margin-left: vwm(17px)
					margin-top: vwm(15px)
					transform: translateX(vwm(30px))
			&--5
				background-image: url(../assets/images/logo-6.png)
				background-size: contain
				background-repeat: no-repeat
				width: vw(132px)
				height: vw(48px)
				margin-top: vw(9px)
				margin-left: vw(24px)
				order: 1
				&:after
					right: vw(-19px)
				@media screen and (max-width: 1000px)
					width: vwm(132px)
					height: vwm(48px)
					margin-right: vwm(7px)
					margin-left: vwm(-11px)
</style>